module.exports = __webpack_public_path__ + "img/env_9.14ed466c.jpg";